// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"cac2d085","453":"20359781","551":"3f6e3e9a","851":"ec3ecaab"}[chunkId] + ".chunk.js";
};